import { render } from "./PopularCollections.vue?vue&type=template&id=570d9666&scoped=true&ts=true"
import script from "./PopularCollections.vue?vue&type=script&lang=ts"
export * from "./PopularCollections.vue?vue&type=script&lang=ts"

import "./PopularCollections.vue?vue&type=style&index=0&id=570d9666&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570d9666"]])

export default __exports__